import { useEffect, useState } from "react";
import { List } from "@mui/material";
import { ListItem } from "@mui/material";
import { ListItemText } from "@mui/material";
import "./user-dropdown.scss";
import Checkbox from "../checkbox/checkbox";
// import Toggle from "../toggle/toggle";
import Typography from "../typography/typography";
// import { FormControlLabel } from "@mui/material";

interface UserDropdownProps {
  value: {
    isRoleVisible: boolean;
    selectedUsers: number[];
  };
  data: any;
  onToggleChange: () => void;
  onCheckboxChange: (values: number[]) => void;
}

export const UserDropdown = (props: UserDropdownProps) => {
  const { value, data,  onCheckboxChange, ...rest } = props;
  const { isRoleVisible, selectedUsers } = value;
  const [checked, setChecked] = useState(selectedUsers);
  const [dropdownData, setDropdownData] = useState([]);

  // const handleToggle = () => {
  //   onToggleChange();
  //   setDropdownData([]);
  // };

  const handleCheckbox = (value: number, item: any) => () => {
    const currentIndex = checked.findIndex(
      (user: any) => (isRoleVisible ? user.id : user.id) === value,
    );
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(item);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    onCheckboxChange(newChecked);
  };

  useEffect(() => {
    if (isRoleVisible) {
      setDropdownData(data?.departments ?? []);
    } else {
      setDropdownData(data?.users ?? []);
    }
    // eslint-disable-next-line
  }, [isRoleVisible, data]);

  return (
    <div className="SwitchList" {...rest}>
    
      <List>
        {dropdownData &&
          dropdownData?.map((item: any) => {
            const labelId = `checkbox-list-secondary-label-${item.id}`;

            return (
              <ListItem key={item.id} sx={{cursor:'pointer'}} onClick={handleCheckbox(
                      isRoleVisible ? item.id : item.id,
                      item, // Pass the entire item to the handleCheckbox function
                    )}>
                <ListItemText id={labelId}>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: `${
                        isRoleVisible
                          ? item?.name
                          : `${item?.first_name} ${item?.last_name}`
                      } <span>${
                        isRoleVisible
                          ? item.count + " Users"
                          : item?.department?.name
                      }</span>`,
                    }}
                  />
                </ListItemText>
                <div className="list-secondary-content">
                  <Checkbox
                    edge="end"
                   
                    checked={checked.some(
                      (user: any) =>
                        (isRoleVisible ? user.id : user.id) ===
                        (isRoleVisible ? item.id : item.id),
                    )}
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </div>
              </ListItem>
            );
          })}
      </List>
    </div>
  );
};

export default UserDropdown;
